export const ROOT = '/tripboard';
export const ROOT2 = `${ROOT}/`;
export const ROOT_LEGACY = '/traveler/scratchpad';

export const API = '/traveler/scratchpad/api';
export const FAVORITES = '/favorites';
export const RECENT = '/recent';
export const RECENT_DETAILS = `${RECENT}/:linkId`;
export const TRIPBOARD = ROOT;
export const TRIPBOARD2 = `${TRIPBOARD}/`;
export const TRIPBOARD_DETAILS = `${TRIPBOARD}/:boardId`;
export const TRIPBOARD_ERROR = `${TRIPBOARD}/error`;
export const TRIPBOARD_MARKETING = `${TRIPBOARD}/m/:boardId`;

export const routes = {
    FAVORITES: `${ROOT_LEGACY}${FAVORITES}`,
    FAVORITES_DETAILS: `${ROOT_LEGACY}${FAVORITES}/:boardId`,
    RECENT,
    RECENT_DETAILS,
    ROOT,
    TRIPBOARD,
    TRIPBOARD_DETAILS,
    TRIPBOARD_ERROR,
    TRIPBOARD_MARKETING
};

export default routes;



// WEBPACK FOOTER //
// ./src/universal/routes.js